module.exports = __webpack_public_path__ + "static/img/main-banner3-blue.73d8ab7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main-banner3-blue.png
// module id = TiAH
// module chunks = 0